<ng-template #newLessonTemplate>
  <div [ngClass]="['new-lesson-tile', courseCssService.responsiveClassNew()]">
    <div [ngClass]="['lesson-tile',  'new']" *ngIf='!newLesson'>
      <h3>New Lesson</h3>
      <button class='add-lesson' (click)='addNewLessonPhase1()'>Add New Lesson</button>
      <input [hidden]='true' type='file' multiple='false' accept='.mtlesson' (change)='importLesson($event)' #fileInput>
      <!-- <button class='import' (click)='fileInput.click()'>Import Lesson</button> -->
    </div>
    <div class='lesson-tile add' *ngIf='newLesson && newLesson.screen == 1'>
      <div class='lesson-top'>
        <label>Name Your Lesson Plan</label>
        <input placeholder='ex. Week One' [(ngModel)]='newLesson.name' (keyup.enter)='addNewLessonPhase2()'>
      </div>
      <div class='lesson-bottom'>
        <button class='cancel' (click)='cancelNewAddLesson()'>Cancel</button>
        <button class='next' [hidden]='newLesson.name.length === 0' (click)='addNewLessonPhase2()'>Next</button>
      </div>
    </div>
    <div class='lesson-tile add' *ngIf='newLesson && newLesson.screen == 2'>
      <div class='lesson-top'>
        <label>Choose One</label>
        <button (click)='chooseNumberOfLessons($event)'>{{ selectedActivitySongsText() }}<i
            class='mt-arrow-down'></i></button>
      </div>
      <div class='lesson-bottom'>
        <button class='cancel' (click)='backNewAddLesson()'>Back</button>
        <button class='done' (click)='addNewLessonDone()'>Add</button>
      </div>
    </div>
  </div>
</ng-template>
<div [ngClass]="['lessons']">
  <div [ngClass]='courseCssService.responsiveClass()' [dragula]='this.dragGroupName' [(dragulaModel)]='lessons'>
    <div class='lesson' *ngFor='let lesson of lessons || []; index as index; trackBy: trackByLessonUuid' id='{{lesson.uuid}}'>
      <ng-container>
          <!-- <button [ngClass]="'drag-icon'" [hidden]='!isEditing'>
            <img src='assets/imgs/hvmove.png'>
          </button> -->
          <app-lesson-tile [lesson]='lesson' [course]='course' [teacher]='teacher'
                           [isEditing]='isEditing' [resources]='resources' [isDragging]="isDragging"></app-lesson-tile>
      </ng-container>
    </div>
    <ng-container [ngTemplateOutlet]='newLessonTemplate'></ng-container>
  </div>
</div>